module.exports = __webpack_public_path__ + "static/media/gbr.2e9c71c7.svg";